<template>
  <!-- 随笔详情页 -->
  <div>
    <header class="white-card">
      <h3 class="center">{{ blog.title }}</h3>
      <div class="statistics">
        <div class="type" :class="getTypeClass(blog.type)">
          {{ typeMap[blog.type] }}
        </div>
        <div class="block">
          <img src="@/assets/images/icon/eye.png" alt="" />
          <span> {{ blog.readingCount || 0 }}</span>
        </div>
        <div class="block">
          <img src="@/assets/images/icon/pinglun.png" alt="" />
          <span>{{ blog.commentCount || 0 }}</span>
        </div>
        <div class="block">
          <img src="@/assets/images/icon/like.png" alt="" />
          <span>
            {{ blog.likeCount || 0 }}
          </span>
        </div>
        <div class="block">
          <img src="@/assets/images/icon/clock.png" alt="" />
          <span>{{ blog.createTime }}</span>
        </div>
      </div>
    </header>
    <section class="white-card">
      <div v-html="blog.content" class="markdown-body"></div>
      <div class="btn-wrap">
        <a class="primary-btn like" @click.stop="like">
          <i class="iconfont icon-dianzan_kuai"></i> 赞 (
          <span>{{ blog.likeCount || 0 }} </span>)
        </a>
      </div>
    </section>
    <footer class="white-card">
      <div class="title-bar">评论</div>
      <div class="img-wrap" v-if="!blog.comments || blog.comments.length == 0">
        <img src="@/assets/images/no-data.png" alt="" />
      </div>
      <div class="comment-box" @click.stop="showPopup">精 彩 等 你 来 评 ~</div>

      <div class="comment-wrap">
        <template v-for="item in blog.comments">
          <commentList :item="item" :key="item.commentId" @show="showPopup"></commentList>
        </template>

        <div class="btn-wrap" v-if="blog.comments && blog.comments.length < allComments.length">
          <button class="primary-btn plain" @click.stop="loadmore">
            加载更多
          </button>
        </div>

        <div v-else-if="blog.comments &&
          blog.comments.length >= allComments.length &&
          blog.comments.length > 0
          " class="no-data">
          <span>~ 已加载全部评论 ~</span>
        </div>
      </div>
    </footer>
    <button class="edit-pen" @click.stop="showPopup">
      <i class="iconfont icon-bi"></i>
    </button>
    <div>
      <popup style="display: none" @hide="hide" id="popup-box-1" :bgColor="'#fff'" :visible="dialogShow">
        <div>
          <div>@{{ commentParams.replyTo }}</div>
          <div class="form-section">
            <div class="box">
              <input type="text" placeholder="昵称(必填)" v-model="commentParams.commentAuthor" />
            </div>
            <div class="box">
              <input type="text" placeholder="邮箱(必填)" v-model.trim="commentParams.commentAuthorEmail" />
            </div>
            <div class="content-box">
              <div class="content scroll-y" contenteditable ref="contentBox" @input="contentEnter"></div>
            </div>
          </div>
          <!-- <div>3</div> -->
          <div class="btn-wrap" style="margin-bottom: 0">
            <button class="primary-btn cancel-btn" @click.stop="hide">
              取消
            </button>
            <button class="primary-btn" @click.stop="comment">确定</button>
          </div>
        </div>
      </popup>
    </div>
  </div>
</template>

<script>
import data from "./index.js";
export default data;
</script>


<style scoped src="./index.css"></style>